module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ach"
  }, [_vm._v("Also in ")]), _c('p', {
    staticClass: "acl"
  }, [_vm._v("THE DEMONATA")]), _c('p', {
    staticClass: "acl"
  }, [_vm._v("Series:")]), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("Lord Loss ")]), _vm._v("(Book 1)")]), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("Demon Thief ")]), _vm._v("(Book 2)")]), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("Slawter ")]), _vm._v("(Book 3)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-744176ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Bec_adca-1.vue
// module id = 63
// module chunks = 0